import React from "react";
import { Modal } from "react-bootstrap";
import ReactJWPlayer from "react-jw-player";

const VideoModal = ({ onClose, show, VideoModalData }) => {


  return (
    <Modal
      show={show}
      onHide={onClose}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Body>
        <ReactJWPlayer
          className={"ssa"}
          playerId={VideoModalData.jwMediaId}
          file={VideoModalData.videoUrl}
          script="https://cdn.jwplayer.com/libraries/niqngNhI.js"
          image={VideoModalData.image}
          isAutoPlay={true}
          customProps={{ skin: { name: "seven" }, width: "100%" }}
          onAdComplete={(e) => console.log("e", e)}
          onTime={(e) => {
            if (e.position === e.duration) {
            }
          }}
        />
      </Modal.Body>
    </Modal>
  );
};

export default VideoModal;
